<script setup lang="ts">
type StudentParentData = App.Students.Data.StudentParentData;

import DangerDialog from '@/components/dialog/DangerDialog.vue';
import Dialog from '@/components/dialog/Dialog.vue';
import StudentProfileParentForm from '@/domains/student-app/components/profile/StudentProfileParentForm.vue';

import Check from '@/icons/line/check.svg';

const props = defineProps<{
  parent: StudentParentData;
}>();

const { show, closeLocally } = useDialog();
const [isCancelDialogOpen, toggleCancelDialog] = useToggle(false);

const isDialogOpen = computed(() => !isCancelDialogOpen.value && show.value);

const form = useForm({
  url: route('student.profile.parent.update', { parent: props.parent.id }),
  method: 'PUT',
  fields: {
    first_name: props.parent.first_name,
    last_name: props.parent.last_name,
    email: props.parent.email,
    cell_phone: props.parent.cell_phone
  }
});

function handleFormSubmit() {
  form.submit();
}

function handleToggleCancelDialog() {
  if (form.isDirty) {
    toggleCancelDialog();
    return;
  }
  closeLocally();
}

function handleCancelDialogConfirm() {
  toggleCancelDialog();
  closeLocally();
}
</script>


					<script lang="ts">
					import __hybridly_layout_0 from '~/resources/layouts/student-parent.vue';
					export default { layout: [__hybridly_layout_0] }
					</script>
					<template>
				
  <Dialog
    title="Edit Parent"
    :confirmButtonIcon="Check"
    :cancelButtonDisabled="!form.isDirty"
    :isLoading="form.processing"
    :isOpen="isDialogOpen"
    cancelButtonLabel="Reset"
    confirmButtonLabel="Save changes"
    @onCancel="form.reset"
    @onClose="handleToggleCancelDialog"
    @onConfirm="handleFormSubmit"
  >
    <template #form>
      <StudentProfileParentForm :form="form" />
    </template>
  </Dialog>
  <DangerDialog
    title="Discard Changes?"
    message="Your changes will not be saved."
    :isOpen="isCancelDialogOpen"
    cancelButtonLabel="Stay on this page"
    confirmButtonLabel="Discard changes"
    isStacked
    @onCancel="toggleCancelDialog"
    @onClose="toggleCancelDialog"
    @onConfirm="handleCancelDialogConfirm"
  />
</template>
